module.exports = __webpack_public_path__ + "static/media/sol2.1921923f.svg";